import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
@Injectable({
  providedIn: 'root'
})
export class ImpresionService {

  constructor() { }
  imprimir (imagenPath :string, encabezado : string [], cuerpo:Array<any>, titulo:string, guardar?:boolean){
    const fontSize = 12;
    const doc = new jsPDF ({
      orientation: "portrait",
      unit: "px",
      format: 'letter'
      // Tamaño de letra personalizado

    });
   doc.setFontSize(fontSize);
    doc.text(titulo, doc.internal.pageSize.width /2, 8,{align: 'center' });

      // Agregar la imagen al documento
      if (imagenPath) {
        const imgData = imagenPath; // Ruta de la imagen en assets
        doc.addImage(imgData, 'JPEG', 40, 5, 35, 25); // Ajusta las coordenadas y el tamaño según tus necesidades
      }
    autoTable(doc,{
      head: [encabezado],
      body:[cuerpo],
    })
    if(guardar) {
      const hoy = new Date();
      doc.save(hoy.getDate()+ hoy.getMonth() + hoy.getFullYear() + hoy.getTime()+'.pdf');
    //  doc.addImage(canvas.toDataURL("image/png"), 'PNG', 30, 30);
    } else  {
  }
}
}
